module.exports = __webpack_public_path__ + "img/calculator.9731378a.png";